import EditableContentBlockPage from "@/pages/EditableContentBlock/EditableContentBlock";

/**
 * First-class rebuilt route for editing admin-authored content blocks that feed
 * customer-app hover help.
 *
 * @see docs/guides/HOVER_HELP.md
 */
export default function EditableContentBlockRoute() {
  return <EditableContentBlockPage />;
}
